import { useApi } from '@/api';
import { Flex, KpiSkeleton, KpiCard } from '@blockanalitica/ui';
import { UpIcon, PieIcon, LockIcon, DoubleUpIcon } from '@/components';

type OverallResponse = {
  tvl: string;
  total_supply: string;
  total_borrow: string;
  tvl_change: string | number;
  total_supply_change: string | number;
  total_borrow_change: string | number;
  tvl_change_percentage: string | number;
  total_supply_change_percentage: string | number;
  total_borrow_change_percentage: string | number;
};

export default function TopKpis() {
  const [data, error] = useApi<OverallResponse>({
    url: '/overall/'
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <KpiSkeleton />;
  }

  return (
    <Flex flexDirection="column" gap={['m', 's']}>
      <KpiCard
        title="Total Market Size"
        data={data}
        field="total_supply"
        options={{
          currency: 'USD',
          trend: true,
          variants: {
            kpiHeader: 'primaryGradient'
          }
        }}
        icon={
          <Flex color="primary">
            <PieIcon size="5" />
          </Flex>
        }
      />

      <Flex flexDirection={['column', 'row']} gap={['m', 's']}>
        <KpiCard
          title="Total Value Locked"
          data={data}
          field="tvl"
          options={{
            currency: 'USD',
            notation: 'compact'
          }}
          icon={
            <Flex color="primary">
              <LockIcon size="5" />
            </Flex>
          }
        />

        <KpiCard
          title="Total Available"
          data={data}
          field="total_available"
          options={{
            currency: 'USD',
            notation: 'compact'
          }}
          icon={
            <Flex color="primary">
              <DoubleUpIcon size="5" />
            </Flex>
          }
        />

        <KpiCard
          title="Total Borrows"
          data={data}
          field="total_borrow"
          options={{
            currency: 'USD',
            notation: 'compact'
          }}
          icon={
            <Flex color="primary">
              <UpIcon size="5" />
            </Flex>
          }
        />
      </Flex>
    </Flex>
  );
}
